import TenantAppSwitcher, { type TenantAppSwitcherProps } from './TenantAppSwitcher'
import CommonServiceContext from '../common/context/CommonServiceContext'
import { useCommonDrawerState } from '../common/context/CommonDrawerContexts'
import type { VFC } from 'react'
import type { CommonModuleState } from '../common/types'

const TenantAppSwitcherWithCommonServiceContext: VFC<TenantAppSwitcherProps & { commonModule: CommonModuleState, pathPrefix: string }> = ({ fallback, fxVars, auth, theme, pathPrefix, commonModule = {} }) => {
  return <CommonServiceContext
    auth={auth}
    commonModule={commonModule}
    commonDrawerState={useCommonDrawerState(commonModule)}
  >
    <TenantAppSwitcher
      fallback={fallback}
      fxVars={fxVars}
      auth={auth}
      theme={theme}
      pathPrefix={pathPrefix}
    />
  </CommonServiceContext>
}

export default TenantAppSwitcherWithCommonServiceContext
